import { Flex, Heading, Spacer } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { ImplementationDetails } from './ImplementationDetails';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { BackButton } from '~/packages/common-frontend/components/BackButton';

// Fragments
const RouteBase = () => (
  <>
    <Flex>
      <Heading mb="24px">Implementations</Heading>
      <Spacer />
      <BackButton />
    </Flex>
    <ImplementationDetails />
  </>
);

// Exports
export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="/settings" />;
    }}
  >
    <RouteBase />
  </RouteErrorBoundary>
);
